module.exports = __webpack_public_path__ + "img/417.b273504c.png";